import {Injectable} from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  HypecastAuthenticationService,
  HypecastCredentials,
} from '@app/shared/authentication/services/authentication.service';
import {__} from '@app/shared/functions/object.functions';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {Logger} from '../logger.service';
import {RouteService} from '../route.service';

const log = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard  {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: HypecastAuthenticationService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const data = RouteService.MergeData(route);

    return this.authenticationService
      .credentials$
      .pipe(
        map((value: HypecastCredentials) => {
          let result: boolean;
          if (!__.IsNullOrUndefined(data['roles'])) {
            result = this.authenticationService.hasAnyRole(data['roles']);
          } else {
            result = !__.IsNullOrUndefined(value);
          }

          if (!result) {
            this.router.navigate(['/login']);
          }
          return result;
        })
      );
  }
}
